// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./double-angle.svg", import.meta.url);
// Module
var code = `<figure> <img src="${___HTML_LOADER_IMPORT_0___}"/> </figure> `;
// Exports
export default code;